(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const blockTitles = document.querySelectorAll('.footer-header-container-js');

  blockTitles.forEach((title) => {
    title.addEventListener('click', () => {
      const block = title.nextElementSibling;
      const cross = title.querySelector('.footer-cross-container');

      if (!block || !cross) return;

      const isExpanded =
        block.getAttribute('data-state') === 'expanded';

      const newState = isExpanded ? 'collapsed' : 'expanded';

      block.setAttribute('data-state', newState);
      cross.setAttribute('data-state', newState);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
